<div x-ng-if="dashboard">
    <div x-adf-dashboard="" x-adf-model="dashboard" x-editable="true"></div>
</div>